// Copyright ©️ 2026 eVolve MEP, LLC

import type { HexTriplet } from '@evolvemep/api-ts';

import questionMarkSvg from 'assets/icons/icon-src/markup/question-mark.svg?raw';
import type { MarkupToolContext } from 'components/Autodesk/extensions/MarkupModeExtension/BaseMarkupTool';
import { makeStampConfig, type StampConfig } from 'components/Autodesk/extensions/MarkupModeExtension/StampMarkup';
import { QUESTION_MARK_PATH_TOKENS } from 'components/Autodesk/extensions/MarkupModeExtension/stampPathTokens/questionMarkPathTokens';
import { StampTool } from 'components/Autodesk/extensions/MarkupModeExtension/StampTool';

export const QUESTION_MARK_CONFIG: StampConfig = makeStampConfig(
  'questionMark',
  'QUESTION-MARK',
  QUESTION_MARK_PATH_TOKENS,
);

export class QuestionMarkTool extends StampTool {
  constructor(context: MarkupToolContext) {
    super(context, {
      type: 'questionMark',
      label: 'Question Mark',
      iconSvg: questionMarkSvg,
      stampConfig: QUESTION_MARK_CONFIG,
      defaults: {
        fillColor: '#7700CC' as HexTriplet, // Purple color.
        stampSize: 24,
      },
    });
  }
}
